import React from 'react';
import {Field} from 'redux-form';
import {Form, Row, Col} from 'react-bootstrap';
import Button from '@material-ui/core/Button';
import {isEmpty} from 'lodash/lang';
import * as fields from 'components/common/fields';
import * as validators from 'utils/validators';
import {buildUserFullName, makeForm} from 'utils/common';

class AssignSubscriptionForm extends React.Component {
  render() {
    const {readers, handleSubmit, pristine, submitting} = this.props;
    return (
      <Form onSubmit={handleSubmit}>
        <Row>
          <Col md={12}>
            <Field
              name="reader"
              label="Assign subscription to reader"
              labelKey="name"
              valueKey="id"
              component={fields.Select}
              options={readers}
              required
              validate={[validators.isRequired]}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <Button type="submit" variant="contained" color="primary" fullWidth disabled={pristine || submitting}>
              Submit
            </Button>
          </Col>
        </Row>
      </Form>
    );
  }
}

const mapStateToProps = (state) => {
  const readers = state.account.getIn(['user', 'readers']).toJS();
  return {
    readers: isEmpty(readers)
      ? []
      : readers.map((reader) => ({
          id: reader.id,
          name: buildUserFullName(reader),
        })),
  };
};

export default makeForm(AssignSubscriptionForm, 'AssignSubscriptionForm', mapStateToProps, null);
